import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b28dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"entry_base_registing_contents_wrapper\" data-v-48b28dcc><div class=\"loader\" data-v-48b28dcc>Loading...</div><div data-v-48b28dcc><p class=\"entry_registering_description_text\" data-v-48b28dcc>アカウントを作成しています。</p><br data-v-48b28dcc><p class=\"entry_registering_description_text\" data-v-48b28dcc>このプロセスには数秒かかる場合があります。</p><p class=\"entry_registering_description_text\" data-v-48b28dcc>次の画面に自動で遷移しますので、</p><p class=\"entry_registering_description_text\" data-v-48b28dcc>このままお待ちください。</p><br data-v-48b28dcc><p class=\"entry_registering_description_text\" data-v-48b28dcc>次の画面からは、</p><p class=\"entry_registering_description_text\" data-v-48b28dcc>詳しいご経歴や、ご希望条件をまとめた</p><p class=\"entry_registering_description_text\" data-v-48b28dcc>キャリアシートをご入力いただけます。</p></div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

import { useRouter } from 'vue-router';
import axios from 'axios';
import { onMounted } from 'vue';
import store from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'Registering',
  setup(__props) {

const router = useRouter();

onMounted(async () => {

  // トークンがない場合、転職希望時期画面に遷移させる
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }

  try {
    await store.dispatch('userRegistration/registAccount');
    router.push({ name: 'b08' });
  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.data.errorDetail.fieldError) {
      console.error(error.response.data.errorDetail.fieldError);
    }
    if (axios.isAxiosError(error) && error.response?.data.errorDetail.globalError) {
      console.error(error.response.data.errorDetail.globalError[0].code);
      const errorCode = error.response.data.errorDetail.globalError[0].code;
      router.push({ name: 'b09', query: { code: errorCode } });
    }
    throw error;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, _hoisted_2))
}
}

})